// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-templates-marketing-page-haven-jsx": () => import("./../../../src/templates/marketingPage-haven.jsx" /* webpackChunkName: "component---src-templates-marketing-page-haven-jsx" */),
  "component---src-templates-marketing-page-lume-jsx": () => import("./../../../src/templates/marketingPage-lume.jsx" /* webpackChunkName: "component---src-templates-marketing-page-lume-jsx" */),
  "component---src-templates-marketing-page-spruce-jsx": () => import("./../../../src/templates/marketingPage-spruce.jsx" /* webpackChunkName: "component---src-templates-marketing-page-spruce-jsx" */)
}

